import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { ReasonForWithdrawal } from "@pages/ApplicationSetting/CashManagementSetting/ReasonForWithdrawal/index";
import Alerts from "@pages/ApplicationSetting/CashManagementSetting/Alerts";
import { Inventar } from "@pages/ApplicationSetting/CashManagementSetting/Inventar";
import { Maintenance } from "@pages/ApplicationSetting/CashManagementSetting/Maintenance";
import { CashFund } from "@pages/ApplicationSetting/CashManagementSetting/CashFund";

import { SystemState } from "@pages/ApplicationSetting/CashManagementSetting/SystemState";
import { AcceptedDenomination } from "@pages/ApplicationSetting/CashManagementSetting/AcceptedDenomination";

import "./index.css";
import { useSelector } from "react-redux";

type MenuWrapperType = {
    rowData: any;
    oneShop: boolean;
    setDataIsUpdated: Function;
    setRowData: Function;
};

type TabsMenuType = {
    title: string;
    content: React.ReactNode;
    subMenu?: {
        title: string;
        content: React.ReactNode;
    }[];
};

export function CashManagementMenuWrapper({
    rowData,
    oneShop,
    setDataIsUpdated,
    setRowData,
}: MenuWrapperType) {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    const [activeSubTab, setActiveSubTab] = React.useState<number>(0);
    const [isSubMenuCollapsed, setIsSubMenuCollapsed] = React.useState<boolean>(
        false
    );

    const tabs: TabsMenuType[] = [
        {
            title: t("Inventar"),
            content: <Inventar rowData={rowData} oneShop={oneShop} />,
        },
        {
            title: t("Cash fund"),
            content: (
                <CashFund
                    rowData={rowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setDataIsUpdated}
                    setRowData={setRowData}
                />
            ),
        },
        {
            title: t("Accepted denomination"),
            content: (
                <AcceptedDenomination
                    rowData={rowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setDataIsUpdated}
                />
            ),
        },
        {
            title: t("Motif de retrait"),
            content: (
                <ReasonForWithdrawal rowData={rowData} oneShop={oneShop} />
            ),
        },
        {
            title: t("Maintenance"),
            content: <Maintenance rowData={rowData} oneShop={oneShop} />,
        },
        {
            title: t("System state"),
            content: <SystemState />,
        },
        {
            title: t("Alerts"),
            content: (
                <Alerts
                    rowData={rowData}
                    oneShop={oneShop}
                    setDataIsUpdated={setDataIsUpdated}
                />
            ),
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
        if (isSubMenuCollapsed === true) {
            setIsSubMenuCollapsed(false);
        }
    }

    function toggleSubNav(tab: number) {
        if (activeSubTab !== tab) {
            setActiveSubTab(tab);
        }
    }

    return (
        <div style={{ display: "grid", gridTemplateColumns: "220px 1fr" }}>
            <Nav
                tabs
                className="d-flex flex-column"
                style={{
                    backgroundColor: mainColor,
                    height: "90%",
                    fontSize: "15px",
                }}
            >
                {tabs.map((element, index) => {
                    return (
                        <NavItem
                            key={index}
                            className={classNames("pb-1", {
                                "active menu-wrapper-items-nav-link-active__clz":
                                    activeTab === index,
                            })}
                        >
                            <NavLink
                                className={classNames(
                                    "border-0 menu-wrapper-nav-link__clz ",
                                    {
                                        "active menu-wrapper-items-nav-link-active__clz":
                                            activeTab === index,
                                    }
                                )}
                                onClick={() => {
                                    toggleNav(index);

                                    if (element.title === t("Configuration")) {
                                        setIsSubMenuCollapsed(
                                            !isSubMenuCollapsed
                                        );
                                    }
                                }}
                            >
                                <span>{element.title}</span>
                            </NavLink>
                            {element.title === t("Configuration") &&
                            isSubMenuCollapsed
                                ? element.subMenu?.map(
                                      (
                                          item: {
                                              title: string;
                                              content: React.ReactNode;
                                          },
                                          subMenuIndex: number
                                      ): JSX.Element => (
                                          <NavLink
                                              disabled={
                                                  item.title ===
                                                  t("Customer account")
                                              }
                                              key={subMenuIndex}
                                              className={classNames(
                                                  "border-0 text-nowrap pl-5 menu-wrapper-nav-link__clz",
                                                  {
                                                      "active options-nav-link-active__clz":
                                                          activeSubTab ===
                                                          subMenuIndex,
                                                  }
                                              )}
                                              onClick={() => {
                                                  toggleSubNav(subMenuIndex);
                                              }}
                                          >
                                              <span className="px-2">
                                                  {item.title}
                                              </span>
                                          </NavLink>
                                      )
                                  )
                                : null}
                        </NavItem>
                    );
                })}
            </Nav>

            <TabContent activeTab={activeTab} style={{ height: "800px" }}>
                {tabs.map((element, index) => {
                    return element.subMenu !== undefined &&
                        isSubMenuCollapsed ? (
                        element.subMenu?.map(({ content }, subMenuIndex) => {
                            return (
                                <TabPane
                                    tabId={index}
                                    className={classNames({
                                        "d-none": subMenuIndex !== activeSubTab,
                                    })}
                                    style={{
                                        height: "100%",
                                        width: "100%",
                                        overflow: "hidden",
                                    }}
                                    key={subMenuIndex}
                                >
                                    {content}
                                </TabPane>
                            );
                        })
                    ) : (
                        <TabPane
                            tabId={index}
                            style={{
                                height: "100%",
                                width: "100%",
                                overflow: "hidden",
                            }}
                            key={index}
                        >
                            {element.content}
                        </TabPane>
                    );
                })}
            </TabContent>
        </div>
    );
}
